import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import { datadogRum } from '@datadog/browser-rum';
import api from '@services/api';
import usePaginationParams from '@hooks/usePaginationParams';

import type { TeamType } from '../types';

const useGetList = () => {
  const [teams, setTeams] = useState<TeamType[]>([]);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(true);

  const getTeams = useCallback(async ({ page = 1, limit = 10, name = '' }) => {
    setLoading(true);
    try {
      const response = await api.get('/teams', {
        params: {
          pageIndex: page,
          pageLimit: limit,
          name,
        },
      });
      setTeams(response.data.data);
      setTotalPages(response.data.total);
    } catch (error) {
      toast.error('Erro ao carregar equipes. Tente novamente mais tarde.');
      datadogRum.addError(new Error('Fail to fetch teams list'), {
        error,
      });
    } finally {
      setLoading(false);
    }
  }, []);

  usePaginationParams({ onParamsChange: getTeams });

  return {
    getTeams,
    teams,
    totalPages,
    loading,
  };
};

export default useGetList;
